// extracted by mini-css-extract-plugin
export default {"affiliatePromoPopupContent":"affiliatePromoPopupContent--x6BzM","animation-bzdot9":"animation-bzdot9--tcfqb"};